'use client';

import { ReactNode, useEffect, useState } from 'react';
import { useAuth } from '@/components/infrastructure/auth-context';
import { useRouter } from 'next/navigation';
import { Skeleton } from 'antd';

interface ProtectedRouteProps {
    children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { tokenCreateResult, isLoading } = useAuth();
    const router = useRouter();
    const [shouldRender, setShouldRender] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    // 1. 首先调用所有 Hooks，确保顺序一致
    useEffect(() => {
        // 只有当加载完成后才判断是否需要重定向
        if (!isLoading) {
            const currentPath =
                typeof window !== 'undefined' ? window.location.pathname : '';

            if (!tokenCreateResult) {
                console.log(
                    `ProtectedRoute: User not logged in, redirecting from ${currentPath} to /login`,
                );
                router.push('/login');
                setShouldRender(false);
            } else {
                console.log(
                    `ProtectedRoute: User logged in, allowing access to ${currentPath}`,
                );
                setShouldRender(true);
            }
        }
    }, [router, tokenCreateResult, isLoading]);

    // 2. 处理加载状态
    if (isLoading && isMounted) {
        return (
            <div style={{ padding: '20px' }}>
                <Skeleton active paragraph={{ rows: 10 }} />
            </div>
        );
    }

    // 3. 未登录状态（已在 useEffect 中处理重定向，这里返回空）
    if (!shouldRender) {
        return null;
    }

    // 4. 已登录状态，渲染受保护内容
    return <>{children}</>;
}
